import { AppState } from "../App";

import { BACK_TO_START_SCREEN, BackToStartScreen } from "./appState";

// for now only contains source rasters
export interface LayerMenu {
  advancedSubmenuOpen: boolean;
  selectedModelRaster: string;
  selectedBackground: "topographic" | "satellite" | "dark";
}

const INITIAL_STATE: LayerMenu = {
  advancedSubmenuOpen: false,
  selectedModelRaster: "",
  selectedBackground: "satellite",
};

export const getAdvancedSubmenuOpen = (state: AppState) => state.layerMenu.advancedSubmenuOpen;
export const getSelectedModelRaster = (state: AppState) => state.layerMenu.selectedModelRaster;
export const getSelectedBackground = (state: AppState) => state.layerMenu.selectedBackground;
export const getDemRasterUrl = (state: AppState) => {
  const selectedRasterString = "dem_file";

  const allUrls = state.layerRasterSourcesMenu.rasterDataUrls;
  const selected = allUrls.find((item) => item.layer === selectedRasterString);

  const minMaxForLayers = state.layerRasterSourcesMenu.minMaxForLayers;
  const minMaxForSelectedLayer = minMaxForLayers.find(
    (item) => item.layer === selectedRasterString
  );

  if (selected && minMaxForSelectedLayer) {
    const tmsUrl = `${selected.tms.url}&vmin=${minMaxForSelectedLayer.min}&vmax=${minMaxForSelectedLayer.max}`;
    return tmsUrl;
  } else {
    return null;
  }
};
export const getSelectedRasterTmsUrl = (state: AppState) => {
  const selectedRasterString = state.layerMenu.selectedModelRaster;

  const allUrls = state.layerRasterSourcesMenu.rasterDataUrls;
  const selected = allUrls.find((item) => item.layer === selectedRasterString);

  const minMaxForLayers = state.layerRasterSourcesMenu.minMaxForLayers;
  const minMaxForSelectedLayer = minMaxForLayers.find(
    (item) => item.layer === selectedRasterString
  );

  if (selected && minMaxForSelectedLayer) {
    const tmsUrl = `${selected.tms.url}&vmin=${minMaxForSelectedLayer.min}&vmax=${minMaxForSelectedLayer.max}`;
    return tmsUrl;
  } else if (selected && !minMaxForSelectedLayer) {
    return selected.tms.url;
  } else {
    return null;
  }
};

const SET_ADVANCED_SUBMENU_OPEN = "LayerMenu/SET_ADVANCED_SUBMENU_OPEN";
const SET_SELECTED_MODEL_RASTER = "layerMenu/SET_SELECTED_MODEL_RASTER";
const SET_SELECTED_BACKGROUND = "layerMenu/SET_SELECTED_BACKGROUND";

interface SetAdvancedSubMenuOpen {
  type: typeof SET_ADVANCED_SUBMENU_OPEN;
  advancedSubmenuOpen: LayerMenu["advancedSubmenuOpen"];
}
interface SetSelectedModelRaster {
  type: typeof SET_SELECTED_MODEL_RASTER;
  selectedModelRaster: LayerMenu["selectedModelRaster"];
}
interface SetSelectedBackground {
  type: typeof SET_SELECTED_BACKGROUND;
  selectedBackground: LayerMenu["selectedBackground"];
}

export const setAdvancedSubMenuOpen = (advancedSubmenuOpen: boolean) => {
  return {
    type: SET_ADVANCED_SUBMENU_OPEN,
    advancedSubmenuOpen: advancedSubmenuOpen,
  };
};

export const setSelectedModelRaster = (selectedModelRaster: string) => {
  return {
    type: SET_SELECTED_MODEL_RASTER,
    selectedModelRaster: selectedModelRaster,
  };
};
export const setSelectedBackground = (selectedBackground: string) => {
  return {
    type: SET_SELECTED_BACKGROUND,
    selectedBackground: selectedBackground,
  };
};

type LayerAction =
  | SetAdvancedSubMenuOpen
  | SetSelectedModelRaster
  | SetSelectedBackground
  | BackToStartScreen;

export default function reducer(state = INITIAL_STATE, action: LayerAction) {
  switch (action.type) {
    case BACK_TO_START_SCREEN:
      return INITIAL_STATE;
    case SET_ADVANCED_SUBMENU_OPEN: {
      // use acoulades for block scoping the consts status message
      const { advancedSubmenuOpen } = action;
      return {
        ...state,
        advancedSubmenuOpen,
      };
    }
    case SET_SELECTED_MODEL_RASTER: {
      const { selectedModelRaster } = action;
      return {
        ...state,
        selectedModelRaster,
      };
    }
    case SET_SELECTED_BACKGROUND: {
      const { selectedBackground } = action;
      return {
        ...state,
        selectedBackground,
      };
    }
    default:
      return state;
  }
}
